import { render, staticRenderFns } from "./modal_logout_fb_tutorial.vue?vue&type=template&id=5a636b28"
import script from "./modal_logout_fb_tutorial.vue?vue&type=script&lang=js"
export * from "./modal_logout_fb_tutorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports